/** Full-lesson TTS + WhisperX word alignment often exceeds the default 120s API timeout. */
export const LEARNING_TUTORIAL_SYNC_TIMEOUT_MS = 120 * 60_000;

/** Pass 1–3 LLM orchestration (large concept trees can exceed 120s). */
export const LEARNING_TUTORIAL_ORCHESTRATION_TIMEOUT_MS = 120 * 60_000;

/** Timeline + AI visuals can run several minutes on large lessons. */
export const LEARNING_TUTORIAL_TIMELINE_TIMEOUT_MS = 120 * 60_000;
